<template>
	<div>
		<b-form @submit="save" @reset="cancel">
			<!--<b-form-group>-->
			<div v-for="(lyrics, index) in lyricsSet">
				<div class="row mt-1">
					<div class="col-sm-8">
						<label>Title</label>
						<b-form-input
							v-model="lyrics.title"
							required
							placeholder="Title"/>
					</div>

					<div class="col-sm-2">
						<label>Language</label>
						<b-form-select
							:options="languages"
							required
							v-model="lyrics.lang">
						</b-form-select>
					</div>

					<div class="col-sm-2">
						<label>&nbsp;</label><br>
						<b-button variant="outline-success" class="mr-2" @click="addLanguage()">+</b-button>
						<b-button variant="outline-danger" @click="removeLanguage(index)">–</b-button>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col">
						<label>Lines</label>
						<b-textarea v-model="lyrics.lines" rows="10" placeholder="Lines" required></b-textarea>
					</div>
				</div>
				<hr>
			</div>

			<div class="mt-2">
				<div class="col">
					<label>Tags</label>
					<multiselect v-model="tags" :options="availableTags" :loading="loadingTags" @search-change="searchTags"
											 :show-no-results="true" :close-on-select="false" :taggable="true" :internal-search="false" :multiple="true"
											 @tag="addTag" @remove="removeTag"
											 tagPlaceholder=""
											 :showLabels="false"
											 :hideSelected="true"
											 placeholder="Tags"
					></multiselect>
				</div>
			</div>
			<div class="mt-2 text-center">
				<b-form-input v-model="pin" type="password" class="mr-1" style="width: 65px; text-align: center; display: inline-block" minlength="4" maxlength="4"
											placeholder="PIN"></b-form-input>
				<b-button v-if="!addition" @click="remove" variant="danger" class="mr-4">Delete</b-button>
				<b-button type="reset" variant="secondary" class="mr-1">Cancel</b-button>
				<b-button v-if="addition" type="submit" :click="save" variant="primary">Add</b-button>
				<b-button v-else :click="save" type="submit" variant="primary">Save</b-button>
			</div>
		</b-form>
	</div>
</template>

<script>
	import axios from '../ConfiguredAxios'
	import Multiselect from 'vue-multiselect'

	function emptyLyrics() {
		return {
			title: "",
			lang: null,
			lines: ""
		}
	}

	export default {
		name: "SongForm",
		components: {Multiselect},
		props: {
			"addition": Boolean,
			"id": Number
		},
		data: function () {
			return {
				lyricsSet: [
					emptyLyrics()
				],
				tags: [],
				availableTags: [],
				loadingTags: false,
				pin: "",
				languages: [
					{value: null, text: "Select..."},
					{value: "en", text: "EN"},
					{value: "pl", text: "PL"},
					{value: "es", text: "ES"},
					{value: "fr", text: "FR"},
					{value: "cz", text: "CZ"}
				]
			}
		},
		methods: {
			searchTags: function (term) {
				this.loadingTags = true
				axios.get("/rest/v1/songs/tags", {
					params: {
						"term": term
					}
				}).then(response => {
					this.availableTags = [].concat(this.tags).concat(response.data)
					this.loadingTags = false
				}).catch(() => {
					this.loadingTags = false
				})
			},
			addTag: function (tag) {
				this.tags.push(tag)
				this.availableTags.push(tag)
			},
			removeTag: function (tag) {
				let newTagsIndex = this.tags.indexOf(tag)
				if (newTagsIndex >= 0) {
					this.tags.splice(newTagsIndex, 1)
					let availableTagsIndex = this.availableTags.indexOf(tag)
					if (availableTagsIndex >= 0) {
						this.availableTags.splice(availableTagsIndex, 1)
					}
				}
			},
			addLanguage: function () {
				this.lyricsSet.push(emptyLyrics()) // TODO first available one
			},
			removeLanguage: function (index) {
				this.lyricsSet.splice(index, 1)
			},
			cancel: function () {
				this.$emit("cancel")
			},
			remove: function () {
				this.$emit("remove", {
					pin: this.pin
				})
			},
			save: function (event) {
				event.preventDefault()
				if (this.validate()) {
					this.$emit("save", {
						data: {
							lyrics: this.lyricsSet.reduce((result, lyrics) => {
								result[lyrics.lang] = {
									"title": lyrics.title,
									"lines": lyrics.lines
								}
								return result
							}, {}),
							artists: [],
							tags: this.tags.map(tag => tag.trim())
						},
						pin: this.pin
					})
				} else {
					alert("Languages are incorrect!")
				}
			},
			load: function (id) {
				axios.get("/rest/v1/songs/" + id).then(response => {
					this.lyricsSet = Object.keys(response.data.lyrics).map(key => {
						let l = response.data.lyrics[key]
						l.lang = key
						return l
					})
					this.tags = response.data.tags
					this.searchTags("")
				})
			},
			validate: function () {
				let allLangsSet = this.lyricsSet.every(value => {
					return value.lang !== null
				})
				let uniqueLangs = this.lyricsSet.every((lyricsA, indexA) => {
					return this.lyricsSet.find((lyricsB, indexB) => {
						return indexA !== indexB && lyricsB.lang === lyricsA.lang
					}) === undefined
				})
				return allLangsSet && uniqueLangs
			}
		},
		created: function () {
			if (!this.addition) {
				this.load(this.id, this.lang)
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>
